import { render, staticRenderFns } from "./HoldingCertificate.vue?vue&type=template&id=91fd1f94&scoped=true&"
import script from "./HoldingCertificate.vue?vue&type=script&lang=js&"
export * from "./HoldingCertificate.vue?vue&type=script&lang=js&"
import style0 from "./HoldingCertificate.vue?vue&type=style&index=0&id=91fd1f94&scoped=true&lang=css&"
import style1 from "./HoldingCertificate.vue?vue&type=style&index=1&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fd1f94",
  null
  
)

export default component.exports